import React, { FC } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import SectionCTA from "../../SectionCTA/SectionCTA";
import { ISectionCTAsGroup } from "../ISectionCTAsGroup";
import { reorderSectionCTA } from "../iSectionCTAsGroup.utils";
import { styles } from "./MovableSectionCTAsGroup.styles";

export const MovableSectionCTAsGroup: FC<ISectionCTAsGroup.IProps> = ({
  value,
  type,
  sections,
  ctaProps,
  onClick,
  showActions,
  onEdit,
  onChange,
  className,
  showOnlyDrag,
}) => {
  const handleDragEnd = function (result) {
    if (!result.destination || result.destination.index === -1) return;
    const updatedSections = reorderSectionCTA(
      sections,
      result.source.index,
      result.destination.index,
    );
    if (onChange) onChange(updatedSections);
  };
  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId={`droppable-${type}`}>
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={className}
          >
            {sections?.map((section, index) => {
              const { label, icon, id, hide } = section;
              if (hide) return null;
              return (
                <div key={id}>
                  {/* Divider BEFORE item (skip first) */}
                  {index !== 0 && <div className={styles.divider} />}

                  <SectionCTA
                    key={id}
                    id={id}
                    index={index}
                    label={label}
                    icon={icon}
                    active={value === id}
                    onClick={(e) => onClick?.({ index, section, event: e })}
                    canDragDrop
                    showActions={showActions}
                    showOnlyDrag={showOnlyDrag}
                    onEdit={(e) => onEdit?.({ index, section, event: e })}
                    {...ctaProps}
                  />
                </div>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
